import React, { Fragment, useEffect, useState } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { AddOption, AreaNameError, Attribute, Description, ProOption, Save, Title } from "../../../Constant";
import { addOption, addOptionRole, viewAttribute, viewAttributeRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { toast } from 'react-toastify';
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import Typeahead from "../../../CommonElements/TypeAhead";
import ColorPicker from "../../Common/ColorField/ColorPicker";

const OptionsAdd = () => {
    const { register, handleSubmit, control, formState: { errors }, watch, setValue } = useForm({
        defaultValues: {
            colorValue: '#000000' // ✅ set your default hex color
        }
    });
    const authState = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [AttributeOption, setAttributeOption] = useState([]);
    const [selectedAttrType, setSelectedAttrType] = useState('');
    const navigate = useNavigate();
    const selectedColorCode = watch('colorValue');

    useEffect(() => {
        attributeData();
    }, []);

    const attributeData = async () => {
        const payment = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewAttribute : viewAttributeRole);
        if (payment.status === true) {
            const set_payment = payment.data.map((items) => ({ value: items.id, label: items.title, type: items.type }))
            setAttributeOption(set_payment)
        } else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const onSubmit = async (data) => {
        setLoading(true);
        const postRequest = { value: data.title, attribute_id: data.attribute.value, label: selectedColorCode }
        const addAreaResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? addOption : addOptionRole, postRequest);
        if (addAreaResponse.status === 200) {
            if (addAreaResponse.data.status === true) {
                toast.success(addAreaResponse.data.message)
                navigate(`${process.env.PUBLIC_URL}/Products/option`);
            } else {
                toast.error(addAreaResponse.data.message)
                setLoading(false);
            }
        } else if (addAreaResponse.status >= 400 && addAreaResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (addAreaResponse.status >= 500 && addAreaResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <Fragment>
            {loading && (<Transparentspinner />)}
            <Breadcrumbs mainTitle={ProOption} parent="Products" title={ProOption} />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{AddOption}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="title">{Title}<span className="requireStar">*</span></Label>
                                <input className="form-control" id="title" type="text" {...register('title', { required: true })} />
                                <span className="text-danger">{errors.title && AreaNameError}</span>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">{Attribute} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="attribute"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={AttributeOption}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                setSelectedAttrType(value?.type || '');
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.paymentmethod?.message}</p>
                            </Col>
                        </Row>
                        {selectedAttrType === 'color' && (
                            <Row className="g-3 pt-3">
                                <Col md="6">
                                    <Label className="form-label" htmlFor="colorValue">Select Color</Label>
                                    <ColorPicker
                                        selectedColorCode={selectedColorCode}
                                        setSelectedColorCode={(color) => {
                                            // setSelectedColorCode(color);
                                            setValue('colorValue', color);
                                        }}
                                    />
                                </Col>
                            </Row>
                        )}
                        <FormGroup>
                        </FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default OptionsAdd;